import { render, staticRenderFns } from "./searchPallets.vue?vue&type=template&id=6c63d082"
import script from "./searchPallets.vue?vue&type=script&lang=js"
export * from "./searchPallets.vue?vue&type=script&lang=js"
import style0 from "./searchPallets.vue?vue&type=style&index=0&id=6c63d082&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports